import type { PersonAccount as PersonAccountModel } from '@/adapters/catalogv1.g';

export function extractPersonAccount(model: PersonAccountModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    personRef: model.person_ref ?? '',
    accountRef: model.account_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogPersonAccount = ReturnType<typeof extractPersonAccount>;
